import React, { useEffect } from 'react'
import { DragSource as dragSource } from 'react-dnd-cjs'
import { source, collect } from './helper'
import classNames from 'classnames'
import { Actions, connect } from '@react-page/core/lib'

const instances = {}

const Draggable = ({ connectDragPreview, connectDragSource, isDragging, children, className }) => {
    useEffect(() => {
        const img = new Image()
        img.onload = () => connectDragPreview(img)
        img.src =
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAhCAYAAACbffiEAAAA6UlEQVRYhe2ZQQ6CMBBFX0njHg7ESXTp1p3uvIBewc3Em3AfdelSFwRDCAm01JRO+pa0lP8zzc9kMCKyAa7AFqhIixdwB44WuACHuHq8KWm1vwtgF1lMCPaWkevUNE3Qr9R17XTu1P5uvUdV+IpbG2qMGBH5xBYRAjUVUWPEjj10SS3XRFry3kha/VBTETVGcmqtDTVGFqdWn7k9ku96f88QNRVRYySn1tpQY8QptXz7qinmnpt7rZTIqbU21BgJ2mv1+XfCDVFTETVGjIg8SG8KP+RZ0I7lU+dmgRNgaKfyZVw9znT/R85fOHJJE77U6UcAAAAASUVORK5CYII='
    }, [])

    const classes = classNames(
        className,
        { 'ory-toolbar-draggable-is-dragged': isDragging },
        'ory-toolbar-draggable'
    )

    return connectDragSource(
        <div data-testid={`drag-point`} className={classes}>
            {children}
        </div>
    )
}

const mapStateToProps = null

const { insertMode, editMode, layoutMode } = Actions.Display
const { clearHover } = Actions.Cell

const mapDispatchToProps = { insertMode, editMode, layoutMode, clearHover }

export default (dragType = 'CELL') => {
    if (!instances[dragType]) {
        instances[dragType] = connect(
            mapStateToProps,
            mapDispatchToProps
        )(dragSource(dragType, source, collect)(Draggable))
    }

    return instances[dragType]
}
